<template>
    <Card>
        <template v-slot:title>Store Groups</template>
        <template v-slot:description>Manage store groups</template>
        <template v-slot:toolbar>
            <button class="btn btn-light-primary" @click="createStoreGroup">
                <i class="fas fa-plus-square"/>
                Create store group
            </button>
        </template>

        <div class="table-responsive">
            <table class="table table-hover table-vertical-center">
                <thead>
                <tr>
                    <th>Group name</th>
                    <th class="text-center">{{ __('general.stores') }}</th>
                    <th class="text-right">{{ __('general.actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="group in paginatedGroups.data">
                    <td>
                        {{ group.name }}
                    </td>
                    <td class="text-center">
                        {{ group.stores_count }}
                    </td>
                    <td class="text-right">
                        <Link as="button" :href="$route('stores.groups.show', group.id)"
                              class="btn btn-xs btn-light-info">
                            <i class="fas fa-edit"/>
                            {{ __('actions.manage_thing', {thing: __('general.stores')}) }}
                        </Link>
                        <button class="btn btn-xs btn-light-danger" @click="deleteStoreGroup(group)">
                            <i class="fas fa-trash ml-1"/>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import { Link } from '@inertiajs/vue2';

export default {
    components: {Card, Link},

    props: {
        paginatedGroups: Object
    },

    methods: {
        createStoreGroup() {
            Swal.fire({
                title: `Create store group`,
                text: 'Please specify a unique name for the group.',
                input: 'text',
                showCancelButton: true,
                confirmButtonText: __('actions.create'),
                cancelButtonText: __('actions.abort'),
            }).then((result) => {
                if (result.value) {
                    this.$inertia.put(this.$route('stores.groups.create'), {
                        name: result.value
                    })
                }
            });
        },

        deleteStoreGroup(group) {
            Swal.fire({
                title: `Delete group "${group.name}"?`,
                text: 'All stores are going to be removed from the group.',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-danger m-0',
                confirmButtonText: __('actions.delete'),
                cancelButtonText: __('actions.abort'),
            }).then((result) => {
                if (result.value) {
                    this.$inertia.delete(this.$route('stores.groups.delete', group.id))
                }
            });
        }
    }
}
</script>
